var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import { Talent } from 'packages/talent/entities/Talent';
import moment from 'moment';
import { CandidateReaction } from 'packages/reactions/Reaction';
import { CallLog } from 'packages/call_logs/CallLog';
var ResultScreenSummary = /** @class */ (function (_super) {
    __extends(ResultScreenSummary, _super);
    function ResultScreenSummary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = null;
        _this.identifier = null;
        return _this;
    }
    return ResultScreenSummary;
}(Entity));
export { ResultScreenSummary };
export var CandidateCategory;
(function (CandidateCategory) {
    CandidateCategory[CandidateCategory["?"] = 0] = "?";
    CandidateCategory[CandidateCategory["A+"] = 1] = "A+";
    CandidateCategory[CandidateCategory["A"] = 2] = "A";
    CandidateCategory[CandidateCategory["B"] = 3] = "B";
    CandidateCategory[CandidateCategory["C"] = 4] = "C";
})(CandidateCategory || (CandidateCategory = {}));
var Candidate = /** @class */ (function (_super) {
    __extends(Candidate, _super);
    function Candidate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.createdAt = null;
        _this.submittedAt = null;
        _this.jobId = null;
        _this.pipelineStage = null;
        _this.talent = new Talent();
        _this.category = null;
        _this.formResult = null;
        _this.unreadEmails = null;
        _this.totalEmails = null;
        _this.totalComments = null;
        _this.hiringCompletedAt = null;
        _this.additionalFormStatus = null;
        _this.additionalQuestionsAnsweredAt = null;
        _this.callLogs = [];
        _this.reactions = [];
        return _this;
    }
    Object.defineProperty(Candidate.prototype, "hasAnsweredAdditionalQuestions", {
        get: function () {
            return this.additionalQuestionsAnsweredAt !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Candidate.prototype, "score", {
        get: function () {
            var _a;
            if (this.category === null) {
                // V1 recruitment only
                return (_a = this.formResult) === null || _a === void 0 ? void 0 : _a.identifier;
            }
            // V2 recruitment
            return {
                0: '?',
                1: 'A+',
                2: 'A',
                3: 'B',
                4: 'C',
            }[this.category];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Candidate.prototype, "processingTime", {
        get: function () {
            if (this.hiringCompletedAt === null) {
                return null;
            }
            return Math.round(moment(this.hiringCompletedAt)
                .diff(moment(this.createdAt), 'h') / 24);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Candidate.prototype, "hoursInFunnel", {
        get: function () {
            return moment().diff(moment(this.createdAt), 'h');
        },
        enumerable: false,
        configurable: true
    });
    Candidate.prototype.toJdsStructure = function () {
        var data = {
            name: this.talent.name,
            enteredAt: moment(this.createdAt)
                .toDate(),
            score: this.score,
            tags: this.talent.tags.map(function (tag) { return tag.toJdsStructure(); }),
            counters: {
                emails: this.totalEmails,
                comments: this.totalComments,
                files: 0,
            },
        };
        if (this.additionalFormStatus) {
            data.additionalFormState = this.additionalFormStatus === 'pending' ? 'sent' : 'replied';
        }
        return data;
    };
    var _a;
    __decorate([
        Type(Talent, 'talent'),
        __metadata("design:type", typeof (_a = typeof Talent !== "undefined" && Talent) === "function" ? _a : Object)
    ], Candidate.prototype, "talent", void 0);
    __decorate([
        Type(ResultScreenSummary),
        __metadata("design:type", ResultScreenSummary)
    ], Candidate.prototype, "formResult", void 0);
    __decorate([
        Type(CallLog),
        __metadata("design:type", Array)
    ], Candidate.prototype, "callLogs", void 0);
    __decorate([
        Type(CandidateReaction),
        __metadata("design:type", Array)
    ], Candidate.prototype, "reactions", void 0);
    return Candidate;
}(Entity));
export { Candidate };
